import { render } from "./BaseRadio.vue?vue&type=template&id=e523882a&scoped=true"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"

import "./BaseRadio.vue?vue&type=style&index=0&id=e523882a&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e523882a"]])

export default __exports__